import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {LoginPage} from './login';
import {AuthProvider} from "../../providers/auth/auth";

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginPage),
  ],
  providers: [AuthProvider]
})
export class LoginPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts